import PropTypes from 'prop-types';
import React from 'react';
import { InView } from 'react-intersection-observer';
import { Image, ImageContainer } from './PlayImage.styles';

const PlayImage = (props) => {
    const {
        src,
        srcSet,
        sizes,
        alt = '',
        fallbackSrc /* eslint-disable-line */,
        height,
        width,
        imageRatio = '16-9',
        ssr,
        children,
        blurred,
        opacity,
        showPlaceholder,
        className,
    } = props;

    if (ssr) {
        return (
            <ImageContainer imageRatio={imageRatio} className={className} opacity={opacity}>
                <Image
                    width={width}
                    height={height}
                    src={src}
                    srcSet={srcSet}
                    sizes={sizes}
                    alt={alt}
                    blurred={blurred}
                    opacity={opacity}
                />

                {children}
            </ImageContainer>
        );
    }

    return (
        <InView rootMargin="200px 0px" triggerOnce>
            {({ inView, ref }) => (
                <ImageContainer imageRatio={imageRatio} ref={ref} className={className} opacity={opacity}>
                    <Image
                        key={src}
                        width={width}
                        height={height}
                        data-src={src}
                        src={inView || ssr ? src : null}
                        srcSet={inView || ssr ? srcSet : null}
                        sizes={sizes}
                        alt={inView || ssr ? alt : ''}
                        loaded={inView || ssr}
                        blurred={blurred}
                        showPlaceholderImage={showPlaceholder}
                        opacity={opacity}
                    />

                    {children}
                </ImageContainer>
            )}
        </InView>
    );
};

PlayImage.propTypes = {
    src: PropTypes.string.isRequired,
    srcSet: PropTypes.string,
    sizes: PropTypes.string,
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    className: PropTypes.string,
    containerClassName: PropTypes.string,
    imageRatio: PropTypes.oneOf(['16-9', 'cinema', 'square', 'imax', '2-3']),
    ssr: PropTypes.bool,
    source: PropTypes.element,
    blurred: PropTypes.bool,
};

PlayImage.defaultProps = {
    alt: '',
    imageRatio: '16-9',
    source: null,
};

export default PlayImage;
